// extracted by mini-css-extract-plugin
export var searchHeader = "_3e-0";
export var searchHeaderDark = "_3e-1";